import React from 'react';
import { Box } from '@mui/material';

import { isVoteStepOngoing } from '../../../../../Utils/Steps';
import UserVotesInfo from '../../../Shared/UserVotesInfo/UserVotesInfo';
import postDatesStatus from '../../../../../Services/postDatesStatus';
import StickyFooterWrapper from '../../StickyFooterWrapper';
import InteractionsBox from '../../../Shared/InteractionsBox';
import { SteppablePostType } from '../../../../../Utils/Types/Steps';

function ConsultationFooter({ post, space }: any) {
  const ongoing = postDatesStatus(post) === 'ongoing';
  const voteStepOngoing = isVoteStepOngoing(post.included.steps, post.type as SteppablePostType);

  if (!ongoing) {
    return null;
  }

  return (
    <StickyFooterWrapper>
      {post?.voting_options && voteStepOngoing && (
        <Box sx={{ mb: 2 }}>
          <UserVotesInfo post={post} space={space} />
        </Box>
      )}
      <InteractionsBox
        post={post}
        space={space}
        direction="row"
        ctaVariant="outlined"
        isResponsive
        onlyPrimaryActions
        size="small"
      />
    </StickyFooterWrapper>
  );
}

export default ConsultationFooter;
